import React, { FC } from 'react';
import { ThemeTypography, ItemCardSmall } from 'DesignSystem';
import { Box } from '@mui/material';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import Moment from 'react-moment';
import { IPlotComment } from 'FeatureModules/Site/types/plot.types';

interface IPlotCommentProps {
  plotComment: IPlotComment;
}

const PlotComment: FC<IPlotCommentProps> = ({ plotComment }) => {
  return (
    <ItemCardSmall>
      <Box display="flex" alignItems="center" gap={1.5}>
        <Box display="flex" flexDirection="column" width={120} gap={0.5}>
          <Box display="flex" alignItems="center" gap={0.5} width="100%">
            <Icon name="calendar" color="gray-80" />
            <ThemeTypography variant="BODY_MEDIUM_BOLD" color="GRAY_80" autoOverflow>
              <Moment format="YYYY-MM-DD">{plotComment.createdTimestamp}</Moment>
            </ThemeTypography>
          </Box>
          <Box display="flex" alignItems="center" gap={0.5} width="100%">
            <Icon name="partner" color="gray-80" />
            <ThemeTypography variant="BODY_MEDIUM_BOLD" color="GRAY_80" autoOverflow>
              {plotComment.userEmail || plotComment.createdBy?.name}
            </ThemeTypography>
          </Box>
        </Box>
        <ThemeTypography variant="BODY_MEDIUM">{plotComment.content}</ThemeTypography>
      </Box>
    </ItemCardSmall>
  );
};

export default PlotComment;
